import React from "react";
import Term from "./term";


class Terms extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
          terms: props.terms //getStore().terms
        };
      }
      getStore = this.props.getStore;
      //updateStore = this.props.updateStore;
      termCallback = (data) => {                
        this.props.termCallback(data);
      }     

    render() {
        return (
            <div>
              {this.state.terms.map(c => <Term callback={this.termCallback} checked={c.checked} id={c.id} key={c.id} title={c.title} items={c.items}/>)}
             </div> 
          );
    }
}
export default Terms;